import {Injectable} from '@angular/core';
// eslint-disable-next-line n/no-extraneous-import
import {HttpClient, HttpContext} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {
  BankSlipValidateResponse,
  Withdrawal,
  WithdrawalPreview,
} from '@gatewee/types/withdrawal';
import {GenericCrudService} from '@gatewee/services/generic-crud.service';
import {SKIP_SPINNER} from '@gatewee/services/tokens/spinner.token';

@Injectable({
  providedIn: 'root',
})
export class WithdrawalsService extends GenericCrudService<Withdrawal> {
  constructor(
    public override http: HttpClient,
    private readonly router: Router,
  ) {
    super('/withdrawals/recipient', http);
  }

  navigateToList(): void {
    void this.router.navigate(['/panel/withdrawals']);
  }

  navigateToView(withdrawal: Withdrawal): void {
    void this.router.navigate(['/panel/withdrawals', 'view', withdrawal.id]);
  }

  rollback(id: Number, internalNotes: string): Observable<Withdrawal> {
    return this.http
      .patch<Withdrawal>(this.baseUrl + '/rollback/' + id, {
        internalNotes,
      })
      .pipe();
  }

  approve(id: Number, internalNotes: string): Observable<Withdrawal> {
    return this.http
      .patch<Withdrawal>(this.baseUrl + '/approve/' + id, {
        internalNotes,
      })
      .pipe();
  }

  tryAgain(id: Number, internalNotes: string): Observable<Withdrawal> {
    return this.http
      .patch<Withdrawal>(this.baseUrl + '/try-again/' + id, {
        internalNotes,
      })
      .pipe();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  preview(value: any) {
    return this.http.post<WithdrawalPreview>(
      '/withdrawals/recipient/preview',
      value,
    );
  }

  validateBankSlip(
    digitableLine: string,
    skipSpinner = false,
  ): Observable<BankSlipValidateResponse> {
    return this.http.post<BankSlipValidateResponse>(
      `${this.baseUrl}/bank-slip/validate`,
      {digitableLine},
      {context: new HttpContext().set(SKIP_SPINNER, skipSpinner)},
    );
  }

  webhookUpdate(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/webhook/update/${id}`, {});
  }
}
